/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.DocumentInfo";
        class DocumentInfoWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("DocumentInfoWidgetTypeClass.createInstance()");
                    return new DocumentInfoWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DocumentInfoWidgetTypeClass._storeHtml()");
                    DocumentInfoWidgetInstanceClass.HtmlData = htmlData;
                    if (DocumentInfoWidgetInstanceClass.HistoryModalHtml != null) {
                        this._presentInstances();
                    }
                };
                this._storeModalHtml = (htmlData) => {
                    this._log.info("DocumentInfoWidgetTypeClass._storeModalHtml()");
                    DocumentInfoWidgetInstanceClass.HistoryModalHtml = htmlData;
                    if (DocumentInfoWidgetInstanceClass.HtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentInfoWidgetTypeClass::constructor");
                if (DocumentInfoWidgetInstanceClass.HtmlData != null && DocumentInfoWidgetInstanceClass.HistoryModalHtml != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (DocumentInfoWidgetInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/DocumentInfo/document-info.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (DocumentInfoWidgetInstanceClass.HistoryModalHtml == null) {
                        core.Loader.getVersionedHTML('widgets/DocumentInfo/doc-info-history-modal.html', this._storeModalHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.DocumentInfoWidgetTypeClass = DocumentInfoWidgetTypeClass;
        class DocumentInfoWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._startEditButton = null;
                this._stealthHideButton = null;
                this._showKeysButton = null;
                this._showNotesButton = null;
                this._showXRefsButton = null;
                this._showHistoryButton = null;
                this._showPropsButton = null;
                this._noteAddButton = null;
                this._directDocKeysEditEnabled = false;
                this._kwComponentContainer = null;
                this._noteComponentContainer = null;
                this._xRefComponentContainer = null;
                this._propsComponentContainer = null;
                this._kwComponent = null;
                this._noteComponentConfig = {};
                this._notesComponent = null;
                this._xRefComponent = null;
                this._propsComponent = null;
                this._propsComponentConfig = null;
                this._dtComponent = null;
                this._dtContainer = null;
                this._showDocHistoryFilterSpan = null;
                this._hideDocHistoryFilterSpan = null;
                this._xRefsFilterText = null;
                this._showXRefsFilterIcon = null;
                this._hideXRefsFilterIcon = null;
                this._xRefsFilter = null;
                // User interface show/hide element configuration
                this._displayKeysButton = true;
                this._displayNotesButton = true;
                this._displayXRefsButton = true;
                this._displayInfoButton = true;
                this._displayHistoryButton = true;
                // Key edit buttons
                this._editContainer = null;
                this._cancelButton = null;
                this._revertButton = null;
                this._applyButton = null;
                // Support for delegation and specific usage modes
                this._acceptDelegation = false;
                this._actingAsDelegate = false;
                this._delegateFor = null;
                this._processDocActivations = true;
                this._processInfoActivations = true;
                // State info
                this._collapseState = "Show";
                this._currentDoc = null;
                //private _currentDocType: OBDocType = null;
                this._currentModalSession = null;
                this._modalLoader = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.RELATED_SLOT_KEY];
                this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this._lastReactedSlots = [];
                this.presentInstance = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = DocumentInfoWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._kwComponentContainer = this._container.querySelector('#docInfoKeywordsContainer');
                    this._noteComponentContainer = this._container.querySelector('#docInfoNotesContainer');
                    this._xRefComponentContainer = this._container.querySelector('#docInfoXRefsContainer');
                    this._propsComponentContainer = this._container.querySelector('#docInfoPropsContainer');
                    this._showKeysButton = this._container.querySelector('#docInfoShowKeysButton');
                    this._showKeysButton.addEventListener('click', this._keysButtonClicked);
                    this._core.Helper.setElementTranslationAttribute(this._showKeysButton, 'title', 'STR_WPT_KEYWORDS');
                    this._showNotesButton = this._container.querySelector('#docInfoShowNotesButton');
                    this._showNotesButton.addEventListener('click', this._notesButtonClicked);
                    this._core.Helper.setElementTranslationAttribute(this._showNotesButton, 'title', 'STR_WPT_NOTES');
                    this._showXRefsButton = this._container.querySelector('#docInfoShowXRefsButton');
                    this._showXRefsButton.addEventListener('click', this._xrefsButtonClicked);
                    this._core.Helper.setElementTranslationAttribute(this._showXRefsButton, 'title', 'STR_WPT_CROSS_REFERENCES');
                    this._showHistoryButton = this._container.querySelector('#docInfoShowHistoryButton');
                    this._showHistoryButton.addEventListener('click', this._historyButtonClicked);
                    this._core.Helper.setElementTranslationAttribute(this._showHistoryButton, 'title', 'STR_WPT_HISTORY');
                    this._showPropsButton = this._container.querySelector('#docInfoShowPropsButton');
                    this._showPropsButton.addEventListener('click', this._propsButtonClicked);
                    this._core.Helper.setElementTranslationAttribute(this._showPropsButton, 'title', 'STR_WPT_DOC_PROPERTIES');
                    this._noteAddButton = this._container.querySelector('#docInfoNoteAddButton');
                    this._noteAddButton.addEventListener('click', this._addNote);
                    this._startEditButton = this._container.querySelector('#docInfoKeyEditButton');
                    this._startEditButton.addEventListener('click', this._startEdit);
                    this._stealthHideButton = this._container.querySelector('#docInfoStealthButton');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    this._xRefsFilterText = this._container.querySelector('#docInfoXRefsFilter');
                    this._xRefsFilterText.addEventListener('keyup', this._doXRefFilter);
                    this._core.Helper.setElementTranslationAttribute(this._xRefsFilterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._xRefsFilterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._showXRefsFilterIcon = this._container.querySelector('#docInfoXRefsShowFilter');
                    this._showXRefsFilterIcon.addEventListener('click', this._showXRefFilter);
                    this._hideXRefsFilterIcon = this._container.querySelector('#docInfoXRefsCancelFilter');
                    this._hideXRefsFilterIcon.addEventListener('click', this._hideXRefFilter);
                    this._container.querySelector('.docInfoXRefsClearFilter').addEventListener('click', this._clearXRefFilter);
                    this._xRefsFilter = this._container.querySelector('.widget__filter');
                    // Edit controls
                    this._editContainer = this._container.querySelector('#docInfoEditControls');
                    this._cancelButton = this._container.querySelector('#docInfoCancelBtn');
                    this._cancelButton.addEventListener('click', this._cancelEdits);
                    this._core.Helper.setElementTranslation(this._cancelButton.querySelector('#docInfoCancelBtnLabel'), 'STR_WPT_CANCEL');
                    this._revertButton = this._container.querySelector('#docInfoRevertBtn');
                    this._revertButton.addEventListener('click', this._revertEntries);
                    this._core.Helper.setElementTranslation(this._revertButton.querySelector('#docInfoRevertBtnLabel'), 'STR_WPT_REVERT');
                    this._applyButton = this._container.querySelector('#docInfoApplyBtn');
                    this._applyButton.addEventListener('click', this._applyEdits);
                    this._core.Helper.setElementTranslation(this._applyButton.querySelector('#docInfoApplyBtnLabel'), 'STR_WPT_APPLY');
                    this._widgets.setTitle(this._config, this._container.querySelector('#docInfoWidgetTitle'), 'STR_WPT_DOC_INFORMATION');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Set up component
                    let config = this._config;
                    if (config.hasOwnProperty('NoteDisplayOptions') && (config.NoteDisplayOptions != null))
                        this._noteComponentConfig = config.NoteDisplayOptions;
                    if (config.hasOwnProperty('PropsDisplayOptions') && (config.PropsDisplayOptions != null))
                        this._propsComponentConfig = config.PropsDisplayOptions;
                    if (config.hasOwnProperty('EnableDirectDocumentEdit') && (config.EnableDirectDocumentEdit != null))
                        this._directDocKeysEditEnabled = config.EnableDirectDocumentEdit;
                    if (config.hasOwnProperty('AcceptDelegation') && (config.AcceptDelegation != null))
                        this._acceptDelegation = config.AcceptDelegation;
                    if (config.hasOwnProperty('ProcessDocumentActivation') && (config.ProcessDocumentActivation != null))
                        this._processDocActivations = config.ProcessDocumentActivation;
                    if (config.hasOwnProperty('ProcessSpecificInfoActivation') && (config.ProcessSpecificInfoActivation != null))
                        this._processInfoActivations = config.ProcessSpecificInfoActivation;
                    if (config.hasOwnProperty('CollapseState') && (config.CollapseState != null))
                        this._collapseState = config.CollapseState;
                    if (config.hasOwnProperty('ShowKeywords') && (config.ShowKeywords != null))
                        this._displayKeysButton = config.ShowKeywords;
                    if (config.hasOwnProperty('ShowNotes') && (config.ShowNotes != null))
                        this._displayNotesButton = config.ShowNotes;
                    if (config.hasOwnProperty('ShowCrossReferences') && (config.ShowCrossReferences != null))
                        this._displayXRefsButton = config.ShowCrossReferences;
                    if (config.hasOwnProperty('ShowProperties') && (config.ShowProperties != null))
                        this._displayInfoButton = config.ShowProperties;
                    if (config.hasOwnProperty('ShowHistory') && (config.ShowHistory != null))
                        this._displayHistoryButton = config.ShowHistory;
                    if (config.hasOwnProperty('ActivateIntoSlots') && (config.ActivateIntoSlots != null) && (config.ActivateIntoSlots.length > 0))
                        this._activateIntoSlots = config.ActivateIntoSlots;
                    if (config.hasOwnProperty("ReactToSlots") && (config.ReactToSlots != null))
                        this._reactToSlots = config.ReactToSlots;
                    // If we are set to hide, need to show a way to re-hide
                    if (this._collapseState == "Stealth")
                        this._core.Functions.showElement(this._stealthHideButton);
                    this._kwComponent = new Widgets.ComponentKeywordsViewEdit(this._core, this._kwComponentContainer, this);
                    this._kwComponent.ErrorCallback = this._callErrorHandler;
                    this._kwComponent.FailCallback = this._callFailedHandler;
                    this._kwComponent.present();
                    this._notesComponent = new Widgets.ComponentNotes(this._core, this._noteComponentContainer, this, this._noteComponentConfig);
                    this._notesComponent.ErrorCallback = this._callErrorHandler;
                    this._notesComponent.FailCallback = this._callFailedHandler;
                    this._notesComponent.present();
                    this._xRefComponent = new Widgets.ComponentCrossReferences(this._core, this._xRefComponentContainer, this);
                    this._xRefComponent.ErrorCallback = this._callErrorHandler;
                    this._xRefComponent.FailCallback = this._callFailedHandler;
                    this._xRefComponent.DocSelectedCallBack = this._xrefSelected;
                    this._xRefComponent.present();
                    this._propsComponent = new Widgets.ComponentDocProperties(this._core, this._propsComponentContainer, this, this._propsComponentConfig);
                    this._propsComponent.ErrorCallback = this._callErrorHandler;
                    this._propsComponent.FailCallback = this._callFailedHandler;
                    this._propsComponent.present();
                    // Come back and show/hide items based on configuration, and select the first visible one
                    let firstVisibleButton = null;
                    if (this._displayKeysButton) {
                        if (!firstVisibleButton)
                            firstVisibleButton = this._showKeysButton;
                    }
                    else
                        this._core.Functions.hideElement(this._showKeysButton);
                    if (this._displayNotesButton) {
                        if (!firstVisibleButton)
                            firstVisibleButton = this._showNotesButton;
                    }
                    else
                        this._core.Functions.hideElement(this._showNotesButton);
                    if (this._displayXRefsButton) {
                        if (!firstVisibleButton)
                            firstVisibleButton = this._showXRefsButton;
                    }
                    else
                        this._core.Functions.hideElement(this._showXRefsButton);
                    if (this._displayInfoButton) {
                        if (!firstVisibleButton)
                            firstVisibleButton = this._showPropsButton;
                    }
                    else
                        this._core.Functions.hideElement(this._showPropsButton);
                    if (this._displayHistoryButton) {
                        if (!firstVisibleButton)
                            firstVisibleButton = this._showHistoryButton;
                    }
                    else
                        this._core.Functions.hideElement(this._showHistoryButton);
                    if (firstVisibleButton) {
                        let event = new Event('click');
                        firstVisibleButton.dispatchEvent(event);
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._startEdit = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._startEdit()");
                    this._kwComponent.Mode = WPTNamespace.MetadataEditors.KeywordEditMode.EDIT;
                    this._core.Functions.hideElement(this._startEditButton);
                    this._core.Functions.showElement(this._editContainer);
                };
                this._cancelEdits = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass.cancelEdits()");
                    this._core.Functions.hideElement(this._editContainer);
                    let request = {
                        Document: this._currentDoc,
                        Mode: WPTNamespace.MetadataEditors.KeywordEditMode.VIEW
                    };
                    this._kwComponent.makeRequest(request);
                    this._core.Functions.showElement(this._startEditButton);
                    this._core.Functions.hideElement(this._editContainer);
                };
                this._revertEntries = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass.revertEntries()");
                    let request = {
                        Document: this._currentDoc,
                        Mode: WPTNamespace.MetadataEditors.KeywordEditMode.EDIT
                    };
                    this._kwComponent.makeRequest(request);
                };
                this._applyEdits = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass.applyEdits()");
                    if (!this._currentDoc)
                        return;
                    if (!this._kwComponent.Valid) {
                        this._core.Helper.presentWarningModal('STR_WPT_REQUIRED_ARCHIVE_KEYS_MISSING');
                        return;
                    }
                    let request = { KeywordRecords: this._kwComponent.KeywordRecords };
                    this._core.Loader.genericServiceCallWithData(`/Documents.svc/rest/UpdateKeywordRecords/${this._currentDoc.ItemNum}`, JSON.stringify(request), this._editApplied, {}, this._callErrorHandler, this._callFailedHandler);
                    this._core.Functions.showElement(this._startEditButton);
                    this._core.Functions.hideElement(this._editContainer);
                    this._kwComponent.Mode = WPTNamespace.MetadataEditors.KeywordEditMode.VIEW;
                };
                this._editApplied = (response) => {
                    
                    if (!response.hasOwnProperty('Documents') || (response.Documents == null) || (response.Documents.length == 0)) {
                        this.addError("Received no document records from keyword update request.");
                    }
                    else {
                        // Set local variable for brevity, and update current request
                        // We really shouldn't have more than one here, so ignore it if we somehow do
                        let doc = response.Documents[0];
                        this.showInfoForDocument(doc);
                        // Tell everyone what we've done
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_KEYWORDS_UPDATED);
                        navEvent.ActivationID = doc.ItemNum;
                        navEvent.PrimaryContext = doc;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._addNote = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._addNote()");
                    this._notesComponent.createNoteInteractive();
                };
                this._stealthHide = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this.showInfoForDocument = (doc) => {
                    this._log.info("DocumentInfoWidgetInstanceClass.showInfoForDocument()");
                    this._currentDoc = doc;
                    let request = {
                        Document: doc,
                        Mode: WPTNamespace.MetadataEditors.KeywordEditMode.VIEW
                    };
                    if (this._kwComponent.makeRequest(request)) {
                        if (this._directDocKeysEditEnabled)
                            this._core.Functions.showElement(this._startEditButton);
                    }
                    this._notesComponent.showNotesForDocument(doc);
                    this._xRefComponent.showRefsForDocument(doc);
                    this._propsComponent.showPropsForDocument(doc);
                    if (this._displayHistoryButton) {
                        let docType = this._core.OBHelper.DownloadDocumentTypeMap[doc.DocType.Name];
                        if (docType && docType.hasOwnProperty('Privileges') && docType.Privileges.hasOwnProperty('DocumentHistory') && docType.Privileges.DocumentHistory == true) {
                            this._core.Functions.showElement(this._showHistoryButton);
                        }
                        else {
                            this._core.Functions.hideElement(this._showHistoryButton);
                        }
                    }
                };
                this.clearDisplay = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass.clearDisplay()");
                    this._currentDoc = null;
                    this._kwComponent.clearDisplay();
                    this._notesComponent.clearDisplay();
                    this._xRefComponent.clearDisplay();
                    this._propsComponent.clearDisplay();
                };
                this._keysButtonClicked = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._keysButtonClicked()");
                    this._showKeysButton.classList.add('widget__menu-item--active');
                    this._showNotesButton.classList.remove('widget__menu-item--active');
                    this._showXRefsButton.classList.remove('widget__menu-item--active');
                    this._showPropsButton.classList.remove('widget__menu-item--active');
                    this._core.Functions.showElement(this._kwComponentContainer);
                    this._core.Functions.hideElement(this._noteComponentContainer);
                    this._core.Functions.hideElement(this._xRefComponentContainer);
                    this._core.Functions.hideElement(this._propsComponentContainer);
                    this._core.Functions.hideElement(this._noteAddButton);
                    this._core.Functions.hideElement(this._showXRefsFilterIcon);
                    this._core.Functions.hideElement(this._hideXRefsFilterIcon);
                    this._core.Functions.hideElement(this._xRefsFilter);
                };
                this._notesButtonClicked = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._notesButtonClicked()");
                    this._showKeysButton.classList.remove('widget__menu-item--active');
                    this._showNotesButton.classList.add('widget__menu-item--active');
                    this._showXRefsButton.classList.remove('widget__menu-item--active');
                    this._showPropsButton.classList.remove('widget__menu-item--active');
                    this._core.Functions.hideElement(this._kwComponentContainer);
                    this._core.Functions.showElement(this._noteComponentContainer);
                    this._core.Functions.hideElement(this._xRefComponentContainer);
                    this._core.Functions.hideElement(this._propsComponentContainer);
                    this._core.Functions.showElement(this._noteAddButton);
                    this._core.Functions.hideElement(this._showXRefsFilterIcon);
                    this._core.Functions.hideElement(this._hideXRefsFilterIcon);
                    this._core.Functions.hideElement(this._xRefsFilter);
                };
                this._xrefsButtonClicked = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._xrefsButtonClicked()");
                    this._showKeysButton.classList.remove('widget__menu-item--active');
                    this._showNotesButton.classList.remove('widget__menu-item--active');
                    this._showXRefsButton.classList.add('widget__menu-item--active');
                    this._showPropsButton.classList.remove('widget__menu-item--active');
                    this._core.Functions.hideElement(this._kwComponentContainer);
                    this._core.Functions.hideElement(this._noteComponentContainer);
                    this._core.Functions.showElement(this._xRefComponentContainer);
                    this._core.Functions.hideElement(this._propsComponentContainer);
                    this._core.Functions.hideElement(this._noteAddButton);
                    if (this._xRefsFilterText.value != "") {
                        this._core.Functions.hideElement(this._showXRefsFilterIcon);
                        this._core.Functions.showElement(this._hideXRefsFilterIcon);
                        this._core.Functions.showElement(this._xRefsFilter);
                    }
                    else {
                        this._core.Functions.showElement(this._showXRefsFilterIcon);
                        this._core.Functions.hideElement(this._hideXRefsFilterIcon);
                        this._core.Functions.hideElement(this._xRefsFilter);
                    }
                };
                this._propsButtonClicked = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._propsButtonClicked()");
                    this._showKeysButton.classList.remove('widget__menu-item--active');
                    this._showNotesButton.classList.remove('widget__menu-item--active');
                    this._showXRefsButton.classList.remove('widget__menu-item--active');
                    this._showPropsButton.classList.add('widget__menu-item--active');
                    this._core.Functions.hideElement(this._kwComponentContainer);
                    this._core.Functions.hideElement(this._noteComponentContainer);
                    this._core.Functions.hideElement(this._xRefComponentContainer);
                    this._core.Functions.showElement(this._propsComponentContainer);
                    this._core.Functions.hideElement(this._noteAddButton);
                    this._core.Functions.hideElement(this._showXRefsFilterIcon);
                    this._core.Functions.hideElement(this._hideXRefsFilterIcon);
                    this._core.Functions.hideElement(this._xRefsFilter);
                };
                this._historyButtonClicked = (event) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._historyButtonClicked()");
                    if (!this._currentDoc)
                        return;
                    // Don't mess with the layout, we're going to pop the history into a modal on demand
                    // Set up modal placeholder
                    let modalSession = 'doc-info-history-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentModalSession = modalSession;
                        let instance = this;
                        modal.JQ.one('hidden.bs.modal', function () {
                            delete instance._dtComponent;
                            instance._currentModalSession = null;
                        });
                        modal.DIV.innerHTML = DocumentInfoWidgetInstanceClass.HistoryModalHtml;
                        this._dtContainer = modal.DIV.querySelector('#docHistoryDataTableContainer');
                        this._showDocHistoryFilterSpan = modal.DIV.querySelector('.docInfoHistoryShowFilter');
                        this._hideDocHistoryFilterSpan = modal.DIV.querySelector('.docInfoHistoryCancelFilter');
                        this._modalLoader = modal.DIV.querySelector('#docHistoryLoader');
                        this._core.Helper.prepareHourglassIcon(this._modalLoader);
                        // Close events and labels
                        let closeButton = modal.DIV.querySelector('#docInfoHistoryOK');
                        let closeSpan = modal.DIV.querySelector('#docInfoHistoryDialogCloseSpan');
                        let closeTranslation = this._core.Locale.getTranslation('STR_WPT_CLOSE');
                        closeButton.querySelector('#docInfoHistoryOKLabel').innerHTML = closeTranslation;
                        closeSpan.setAttribute('title', closeTranslation);
                        closeSpan.setAttribute('aria-label', closeTranslation);
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#docInfoHistoryDialogHeading'), 'STR_WPT_DOC_HISTORY');
                        // Component setup
                        this._dtComponent = new Widgets.ComponentDataTable(this._core, this._dtContainer, this);
                        this._dtComponent.present();
                        this._showDocHistoryFilterSpan.addEventListener('click', this._showDocHistoryFilter);
                        this._hideDocHistoryFilterSpan.addEventListener('click', this._hideDocHistoryFilter);
                        this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetDocumentHistory/${this._currentDoc.ItemNum}`, this._receivedHistory, this._callErrorHandler, this._callFailedHandler);
                        this._core.showModal(this._currentModalSession);
                    }
                    else {
                        console.error("unable to show document history modal, modal placeholder is already used");
                    }
                };
                this._receivedHistory = (response) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._receivedHistory()");
                    this._core.Functions.hideElement(this._modalLoader);
                    this._core.Functions.showElement(this._dtContainer);
                    // Fill in the table here
                    let columns = [];
                    columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_DATE'), FilterType: "Text" });
                    columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_HISTORY_ACTION'), FilterType: "Select" });
                    columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_LABEL_USER'), FilterType: "Select" });
                    columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_LABEL_DESCRIPTION'), FilterType: "Text" });
                    let settings = {};
                    settings.Order = [[0, "desc"]];
                    let rows = [];
                    let history = [];
                    if (response.hasOwnProperty('HistoryList') && response.HistoryList)
                        history = response.HistoryList;
                    for (let i = 0; i < history.length; i++) {
                        let entry = history[i];
                        let metaValues = [];
                        let rowValues = [];
                        let rowData = {
                            Values: rowValues,
                            Metadata: metaValues
                        };
                        let dateCellValue = {
                            Value: "",
                            Display: "",
                            Sort: "",
                            Filter: ""
                        };
                        if (entry.Date !== null && entry.Date !== undefined && entry.Date !== "") {
                            let dateTimeValue = this._core.Functions.getTimezoneCorrectedDateTime(entry.Date);
                            let dateTimeValueString = this._core.Locale.DatetimeFormatter.format(dateTimeValue);
                            dateCellValue.Value = dateTimeValue.getTime();
                            dateCellValue.Sort = dateTimeValue.getTime();
                            dateCellValue.Display = dateTimeValueString;
                            dateCellValue.Filter = entry.Date + " " + dateTimeValueString;
                        }
                        rowValues.push(dateCellValue);
                        rowValues.push({ Value: entry.Action, Display: entry.Action, Sort: entry.Action, Filter: entry.Action });
                        rowValues.push({ Value: entry.User, Display: entry.User, Sort: entry.User, Filter: entry.User });
                        rowValues.push({ Value: entry.Desc, Display: entry.Desc, Sort: entry.Desc, Filter: entry.Desc });
                        rows.push(rowData);
                    }
                    let tableData = {
                        Columns: columns,
                        Rows: rows,
                        Settings: settings
                    };
                    this._dtComponent.displayData(tableData);
                };
                this._showDocHistoryFilter = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass._showDocHistoryFilter()");
                    this._core.Functions.hideElement(this._showDocHistoryFilterSpan);
                    this._core.Functions.showElement(this._hideDocHistoryFilterSpan);
                    this._dtComponent.showFilterRow();
                };
                this._hideDocHistoryFilter = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass._hideDocHistoryFilter()");
                    this._core.Functions.hideElement(this._hideDocHistoryFilterSpan);
                    this._core.Functions.showElement(this._showDocHistoryFilterSpan);
                    this._dtComponent.hideFilterRow();
                };
                this._xrefSelected = (doc) => {
                    this._log.info("DocumentInfoWidgetInstanceClass._xrefSelected()");
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = doc.ItemNum;
                    navEvent.PrimaryContext = doc;
                    navEvent.Slots = this._activateIntoSlots;
                    navEvent.Layout = this._currentLayout;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showXRefFilter = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass._showXRefFilter()");
                    this._core.Functions.hideElement(this._showXRefsFilterIcon);
                    this._core.Functions.showElement(this._hideXRefsFilterIcon);
                    this._core.Functions.showElement(this._xRefsFilter);
                    this._xRefsFilterText.focus();
                };
                this._hideXRefFilter = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass._hideXRefFilter()");
                    this._core.Functions.hideElement(this._hideXRefsFilterIcon);
                    this._core.Functions.showElement(this._showXRefsFilterIcon);
                    this._core.Functions.hideElement(this._xRefsFilter);
                    this._clearXRefFilter();
                };
                this._clearXRefFilter = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass._clearXRefFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._xRefsFilterText);
                    this._doXRefFilter();
                };
                this._doXRefFilter = () => {
                    this._log.info("DocumentInfoWidgetInstanceClass._doXRefFilter()");
                    let filterText = this._xRefsFilterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    this._xRefComponent.filterReferences(filterText);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentInfoWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            requestDirectConnection(service, requestor) {
                this._log.info("DocumentInfoWidgetInstanceClass.requestDirectConnection()");
                // Accept first delegation request we get, assuming we are amenable to any requests
                if (this._acceptDelegation && !this._actingAsDelegate) {
                    this._actingAsDelegate = true;
                    this._delegateFor = requestor;
                    return true;
                }
                else
                    return false;
            }
            activate(context) {
                this._log.info("DocumentInfoWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                // Don't respond to update events, we are directy working for another widget
                if (this._actingAsDelegate)
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (this._processDocActivations && slots.length > 0) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                this.showInfoForDocument(this._core.Context.PrimaryDocument);
                                // only remember slots we react to
                                this._lastReactedSlots = slots;
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DISPLAY_DOC_PROPS:
                        if (this._processInfoActivations) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                    this.showInfoForDocument(this._core.Context.PrimaryDocument);
                                }
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_KEYWORDS_UPDATED:
                        if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                            if (this._currentDoc.ItemNum == context.ActivationID)
                                this.showInfoForDocument(this._core.Context.PrimaryDocument);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.NOTE_CREATED:
                        this._notesComponent.showNotesForDocumentId(context.ActivationID);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this.clearDisplay();
                            if (this._collapseState == "Stealth")
                                this._core.Functions.hideElement(this._outerDiv);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_TO_ADVERTISE:
                        if (this._acceptDelegation) {
                            let serviceEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_SERVICE_PROVIDED);
                            serviceEvent.ActivationID = 0;
                            serviceEvent.PrimaryContext = ["DocumentInfo"];
                            serviceEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(serviceEvent);
                        }
                        let capabilityEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_CAPABILITY_PUBLISHED);
                        capabilityEvent.ActivationID = 0;
                        capabilityEvent.PrimaryContext = ["DocumentInfo"];
                        capabilityEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(capabilityEvent);
                        break;
                }
            }
        }
        DocumentInfoWidgetInstanceClass.HtmlData = null;
        DocumentInfoWidgetInstanceClass.HistoryModalHtml = null;
        Widgets.DocumentInfoWidgetInstanceClass = DocumentInfoWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
